export default __webpack_public_path__ + "b86cec91330cc1aa8861e68c5ec121cc.ttf";